import { render, staticRenderFns } from "./AddTicketForm.vue?vue&type=template&id=67886db8&"
import script from "./AddTicketForm.vue?vue&type=script&lang=ts&"
export * from "./AddTicketForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports